export default __webpack_public_path__ + "static/media/TERMINAL_ICON_BLACK.a452cc3f.svg";